import { render, staticRenderFns } from "./forward-msg-popup.html?vue&type=template&id=80c66f12&scoped=true&external"
import script from "./forward-msg-popup.js?vue&type=script&lang=js&external"
export * from "./forward-msg-popup.js?vue&type=script&lang=js&external"
import style0 from "./forward-msg-popup.scss?vue&type=style&index=0&id=80c66f12&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c66f12",
  null
  
)

export default component.exports